import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/computebox/code/feelgood-health-raw/feelgoodhealthwill/node_modules/next/dist/client/app-dir/link.js");
